import React from 'react';
import EnableIcon from 'material-ui-icons/CheckCircle';
import DisableIcon from 'material-ui-icons/VisibilityOff';
import {
    IconButton,
    Tooltip
} from 'material-ui';

const TranslationsTableItemActionsStatus = ({
        blockTranslation,
        classes,
        handleDisable,
        handleEnable
    }) => {

    if (blockTranslation.is_enabled) {
        return (
            <span className={classes.tableIconBtn}>
                <Tooltip title="Disable Translation">
                    <IconButton className="smallIconButton disableColor" onClick={e => handleDisable(blockTranslation.id)}>
                        <DisableIcon />
                    </IconButton>
                </Tooltip>
            </span>
        )
    }
    return (
        <span className={classes.tableIconBtn}>
            <Tooltip title="Enable Translation">
                <IconButton className="smallIconButton enableColor" onClick={e => handleEnable(blockTranslation.id)}>
                    <EnableIcon />
                </IconButton>
            </Tooltip>
        </span>
    );
};

export default TranslationsTableItemActionsStatus;


// WEBPACK FOOTER //
// ./src/containers/blocks/translations/TranslationsTableItemActionsStatus.jsx